import { render, staticRenderFns } from "./ViewAllTeams.vue?vue&type=template&id=1d64ec88"
import script from "./ViewAllTeams.vue?vue&type=script&lang=js"
export * from "./ViewAllTeams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports